











import Vue from 'vue';
import DomEventHelper from '@/helpers/DomEventHelper';
import NewsletterDescription from './newslettersection/NewsletterDescription.vue';
import NewsletterForm from './newslettersection/NewsletterForm.vue';
import { INewsletterFormData } from '../../../common/interfaces/frontpage.interface';

export default Vue.extend({
  name: `NewsletterSection`,
  components: { NewsletterDescription, NewsletterForm },
  props: {
    registrationInProgress: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    DomEventHelper.fireEvent({ name: `newsletter-section-loaded` });
  },
  methods: {
    submitNewsletterSubscription(data: INewsletterFormData): void {
      this.$emit(`subscribe:newsletter`, data);
    },
  },
});
